import React, { useState, useContext, useEffect, useCallback } from "react";
import "./payment.css"
import { Context } from "../../app";
import { 
    PayPalScriptProvider, 
    PayPalButtons,
    PayPalMarks 
} from "@paypal/react-paypal-js";
import { useNavigate } from "react-router-dom";
import { Mixpanel } from "../../Mixpanel";
import axios from "axios";


import CustomerInfo from "../customerInfo/customerInfo";


function Payment(props) {

    const [name, setName] = useState("")
    const [number, setNumber] = useState("")
    // const [email, setEmail] = useState(localStorage.getItem("email")?localStorage.getItem("email"):"")
    const [street, setStreet] = useState("")
    const [street2, setStreet2] = useState("")
    const [city, setCity] = useState("")
    const [state, setState] = useState("Alabama")
    const [postcode, setPostcode] = useState("")
    const [policy, setPolicy] = useState("")

    const shop = useContext(Context)
    let navigate = useNavigate()

    const fundingSources = ["paypal", "card", "paylater"];
	// Remember the amount props is received from the control panel
	const [selectedFundingSource, setSelectedFundingSource] = useState(
		fundingSources[1]
	);

    useEffect(()=>{
        
    },[])

    useEffect(()=>{
        if (shop.mpid && policy!=="") {
            let pol
            if (policy===0) {
                pol = "Return Policy"
            }
            else if (policy===1) {
                pol = "Shipping Details"
            }
            else if (policy===2) {
                pol = "Checkout Details"
            }
            axios({
                url:shop.url+"mixpanel",
                method:"POST",
                headers:{"Content-Type":"application/json"},
                data:{
                    event:"policyCard",
                    properties:{
                        policy:pol
                    },
                    id:shop.mpid
                }
            }).then((res)=>{

            })
            .catch((e)=>console.log(e))
        }
        
    }, [policy])
    

    const createOrder = useCallback((data, actions)=>{
        console.log("started")
        if (shop.mpid) {
            axios({
                url:shop.url+"mixpanel",
                method:"POST",
                headers:{"Content-Type":"application/json"},
                data:{
                    event:"paymentInitiated",
                    properties:{
                        cart: shop.cart, 
                        name:name, 
                        email:props.email, 
                        number:number, 
                        street:street, 
                        street2:street2, 
                        city:city, 
                        state:state, 
                        postcode:postcode
                    },
                    id:shop.mpid
                }
            }).then((res)=>{

            })
            .catch((e)=>console.log(e))
        }
        return actions.order.create({
            purchase_units: [
                {
                    description:"Order details",
                    items: shop.cart.map((item)=>{return { 
                        name: item.name, 
                        quantity: item.quantity, 
                        unit_amount: {
                            currency_code: "USD",
                            value:item.discount,
                        }, 
                        // tax: {
                        //     currency_code:"USD",
                        //     value:(item.price*item.quantity*0.06).toFixed(2)
                        // }
                        
                    }}),
                    amount: {
                        currency_code:"USD",
                        value:(shop.discount*1.06).toFixed(2),
                        breakdown: {
                            item_total:{
                                currency_code:"USD",
                                value:Number(shop.discount).toFixed(2)
                            },
                            shipping:{
                                currency_code:"USD",
                                value:"0"
                            },
                            tax_total: {
                                currency_code:"USD",
                                value:(shop.discount*0.06).toFixed(2)
                            }
                        },
                        
                    },
                }
            ], 
            // payment_source: {
            //     paypal: {
            //         email_address:props.email,
            //         name:{
            //             given_name:name,
            //             surname:""
            //         },
            //         // phone:{
            //         //     phone_type:"MOBILE",
            //         //     phone_number: {
            //         //         national_number:number
            //         //     }
            //         // },
            //         address: {
            //             address_line_1: street,
            //             address_line_2:street2,
            //             admin_area_2:city,
            //             admin_area_1:state,
            //             postal_code:postcode,
            //             country_code: "US"
            //         }
            //     }
            // }
        })
    }, [props.email, name, number, street, street2, city, state, postcode, shop.cart, shop.total])
   
    
    // const initializePayment = usePaystackPayment(config)
    
    // console.log( "yo", (shop.total*0.06).toFixed(2), shop.cart.reduce((sum,curr)=>sum+(curr.price*curr.quantity*0.06)))
    
    
    const paySuccess = (ref)=>{
        // console.log(ref)
    }

    const payClose = ()=>{
        // console.log("Closed")
    }

    function onChange(event) {
		setSelectedFundingSource(event.target.value);
	}

    return(
        <div  className="payment">
            {/* <p>Shipping Details</p> */}
            <CustomerInfo 
                name={name} setName={setName}
                number={number} setNumber={setNumber}
                email={props.email} setEmail={props.setEmail}
                street={street} setStreet={setStreet}
                street2={street2} setStreet2={setStreet2}
                city={city} setCity={setCity}
                state={state} setState={setState}
                postcode={postcode} setPostcode={setPostcode}
            />
            
            <PayPalScriptProvider  
                options={{ 
                    clientId: "AbjL9Ly9BFg3vRQ9KF_Rf-VEmllaXoFnR15ctuRr_8twmwwN9GRXsY9jU8Kck4XIB-mi_DxJDOoBS4Sr", 
                    currency:"USD", 
                    intent:"capture", 
                    components:"buttons" 
                }}>
                {/* <form style={{ minHeight: "200px" }}>
                    {fundingSources.map((fundingSource) => (
                        <label className="mark" key={fundingSource}>
                            <input
                                defaultChecked={
                                    fundingSource === selectedFundingSource
                                }
                                onChange={onChange}
                                type="radio"
                                name="fundingSource"
                                value={fundingSource}
                            />
                            <PayPalMarks
                                fundingSource={fundingSource} 
                                className="checkout-paypal-buttons"    
                            />
                        </label>
                    ))}
                </form> */}
                <p style={{position:"relative", bottom:"20px"}}>Select Payment Method</p>
                {

                    <PayPalButtons className="checkout-paypal-buttons"
                        style={{ 
                            layout: "horizontal",
                            shape:"rect",
                            // tagline:"true",
                            height:45,
                            label:"paypal"

                        }}
                        fundingSource={selectedFundingSource}
                        createOrder={createOrder}
                        onApprove={async (data,actions)=>{
                            const order = await actions.order.capture()
                            
                            window.location.href = "https://www.myvigilapp.com/thank-you.html"

                        }}
                        onError={(err)=>{
                            alert("Please make sure that your cart has items in it")
                            if (shop.mpid) {
                                axios({
                                    url:shop.url+"mixpanel",
                                    method:"POST",
                                    headers:{"Content-Type":"application/json"},
                                    data:{
                                        event:"paymentError",
                                        properties:{
                                            error:err
                                        },
                                        id:shop.mpid
                                    }
                                }).then((res)=>{

                                })
                                .catch((e)=>console.log(e))
                            }
                            
                        }}
                        forceReRender={[createOrder, selectedFundingSource]}
                        
                    />
                }
                <p style={{position:"relative", bottom:"25px"}}><i className="material-icons">minimize</i> or <i className="material-icons">minimize</i></p>
                {

                    <PayPalButtons className="checkout-paypal-buttons"
                        style={{ 
                            layout: "horizontal",
                            shape:"rect",
                            tagline:"true",
                            height:45,
                            label:"paypal"

                        }}
                        fundingSource={fundingSources[0]}
                        createOrder={createOrder}
                    
                        onApprove={async (data,actions)=>{
                            const order = await actions.order.capture()
                            
                            window.location.href = "https://www.myvigilapp.com/thank-you.html"

                        }}
                        onError={(err)=>{
                            alert("Please make sure that your cart has items in it")
                            if (shop.mpid) {
                                axios({
                                    url:shop.url+"mixpanel",
                                    method:"POST",
                                    headers:{"Content-Type":"application/json"},
                                    data:{
                                        event:"paymentError",
                                        properties:{
                                            error:err
                                        },
                                        id:shop.mpid
                                    }
                                }).then((res)=>{

                                })
                                .catch((e)=>console.log(e))
                            }
                            
                        }}
                        forceReRender={[createOrder, selectedFundingSource]}
                        
                    />
                    }
            </PayPalScriptProvider>
            <div className="badges">
                
                <a  title="PayPal Acceptance Mark"><img width={"100px"} src="https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/C2/logos-buttons/optimize/logo-center-other-options-blue-secured-pp.png" border="0" alt="PayPal Acceptance Mark" /></a>
            </div>
            <div className="checkout-policies">
                <div style={{maxHeight:`${policy===0?"500px":"80px"}`}} className="policy">
                    <p onClick={()=>setPolicy(policy===0?"":0)} className="policy-title">
                        <i className="material-icons-outlined">u_turn_right</i>
                        Return Policy
                        <i className="material-icons-outlined">{policy===0?"expand_less":"expand_more"}</i>
                    </p>
                    <p className="policy-details">
                        You are entitled to a full refund up till 30 days past your delivery date, and can request one by simply sending us an email (no questions asked).
                    </p>
                </div>
                <div style={{maxHeight:`${policy===1?"500px":"80px"}`}} className="policy">
                    <p onClick={()=>setPolicy(policy===1?"":1)} className="policy-title">
                        <i className="material-icons-outlined">local_shipping</i>
                        Shipping Details
                        <i className="material-icons-outlined">{policy===1?"expand_less":"expand_more"}</i>
                    </p>
                    
                    <p className="policy-details">
                        All items are shipped the same day if the order is placed before 4PM EST, or shipped the next day if placed after that.
                        Additionally, free shipping is provided for all orders within the US.
                    </p>
                </div>
                <div style={{maxHeight:`${policy===2?"500px":"80px"}`}} className="policy">
                    <p onClick={()=>setPolicy(policy===2?"":2)} className="policy-title">
                        <i className="material-icons-outlined">lock</i>
                        Checkout Details
                        <i className="material-icons-outlined">{policy===2?"expand_less":"expand_more"}</i>
                    </p>
                    <p className="policy-details">
                        To ensure that your payment is secure and well protected, we use PayPal as our payment processor. To place your your order,
                        click on of the paypal buttons to enter billing and shipping information. If you want to simply use a card, click the
                        "Debit or Credit Card" option in black.
                    </p>
                </div>
            </div>
            
        </div>
    )
}

export default Payment